import { Modal, Button, Input, Form, Row } from 'antd'
import { useState } from 'react'
import './ModalSaveOrderTemplate.style.less'

interface Props {
  open: boolean
  onClose: () => void
  onSave: (value) => void
}

function ModalSaveOrderTemplate(props: Props) {
  const [form] = Form.useForm()

  const [requiredName, setrequiredName] = useState(true)

  const onTypeInName = () => {
    setrequiredName(true)
    form.setFieldValue('templates', '')
  }

  return (
    <Modal
      className="modal-save-template-container"
      open={props.open}
      onCancel={props.onClose}
      destroyOnClose
      centered
      footer={false}
    >
      <p className="title">Save as New Template</p>
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          rules={[
            {
              required: requiredName,
              message: 'This field is required',
            },
          ]}
        >
          <Input
            onChange={onTypeInName}
            placeholder="Template Name"
            size="large"
          />
        </Form.Item>
      </Form>

      <Row className="button-container">
        <Button onClick={props.onClose} size="large" className="cancel-button">
          Cancel
        </Button>
        <Button
          size="large"
          type="primary"
          onClick={async () => {
            await form.validateFields()
            props.onSave(form.getFieldsValue())
          }}
        >
          Save
        </Button>
      </Row>
    </Modal>
  )
}

export default ModalSaveOrderTemplate
